module.exports = __webpack_public_path__ + "assets/img/logo.62aa6aa8.png";